import React,{useRef,useEffect,useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/styles";
import axios from 'axios'

const drawerWidth = 300;


const filter = createFilterOptions();

const materialTheme = createTheme(({
    // set default for now
  }));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
}));



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



function ViewAccountInformation(props) {
    const classes = useStyles();

    const [isSavingAccount,setIsSavingAccount] = useState(false)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [isSavingSuccess,setIsSavingSuccess] = useState(false)
    const [messageDialogMessage,setMessageDialogMessage] = useState("")


  

    function messageDialog(){
        return(
          <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={showMessageDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
             {messageDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{
                setShowMessageDialog(false)

                if(isSavingSuccess){
                    props.setShowAccountInformation(false)
                }
                

                }} 
              color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        )
    }


    if(props.selectedAccount == null){
      return(
        <div></div>
      )
    }

    return (
        <div>
           <Dialog fullScreen open={props.showAccountInformation} onClose={()=>{props.setShowAccountInformation(false)}} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{props.setShowAccountInformation(false)}}
                        aria-label="close"
                        size="large">
                    <CloseIcon />
                    </IconButton>
                    <Typography variant="subtitle1" className={classes.title}>
                       Account Information
                    </Typography>
                    <div className={classes.grow} />
                    <IconButton color="inherit" onClick={props.editAccountClickListener} size="large">
                    <EditIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div className={classes.appBarSpacer}></div>
            <div style={{padding:'.5rem'}}>
               
            <Grid container spacing={1}>
                <Grid item xs={12} >Account Name:</Grid>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" className={classes.title}>
                      {props.selectedAccount.account_name} <small>({props.selectedAccount.account_code})</small>
                       
                    </Typography>
                    
                </Grid>

               
                <Grid item xs={12} >Owner Name: </Grid>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" className={classes.title}>
                       {props.selectedAccount.owner_first_name} {props.selectedAccount.owner_last_name}
                    </Typography>
                </Grid>
                <Grid item xs={12} >Contact Number: </Grid>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" className={classes.title}>
                      {props.selectedAccount.contact_number}
                    </Typography>
                </Grid>

                <Grid item xs={12} >Address:</Grid>
                <Grid item xs={12}>
                    <Typography variant="subtitle1" className={classes.title}>
                     {props.selectedAccount.street} {props.selectedAccount.barangay} {props.selectedAccount.city_municipality} {props.selectedAccount.province}
                    </Typography>
                </Grid>
           
            </Grid>
            </div>
      </Dialog>
        </div>
    );
}

export default ViewAccountInformation